var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Diploma = function Diploma(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.544 8.276c.726-.714.95-1.605.832-2.48-.117-.868-.568-1.72-1.187-2.391-.62-.672-1.425-1.183-2.27-1.348-.856-.167-1.745.022-2.493.738L3.004 15.934l-.005.005c-.593.653-.78 1.45-.785 2.2v.006c.044 1.981 1.63 3.692 3.519 3.854l.01.001h.01c.824-.002 1.55-.18 2.245-.64l.017-.013 6.364-6.124 3.43 3.738-.436-3.754 3.665.567-3.497-3.7 4-3.794.003-.004Zm-2.796-4.564c-.432-.105-.848-.03-1.192.308L13.85 7.667c.623.21 1.214.608 1.717 1.1a5.864 5.864 0 0 1 1.25 1.781l3.595-3.496c.323-.312.414-.726.329-1.18-.087-.461-.354-.948-.725-1.35-.37-.404-.826-.702-1.269-.81Zm-6.896 5.934c.196-.326.53-.52.89-.565.642.008 1.354.44 1.92 1.088.569.65.94 1.462.94 2.144v.09l.926 1.03-.989-.15.107.926-.455-.477c-.127-.913-.621-1.826-1.266-2.567-.594-.682-1.334-1.239-2.073-1.52Zm-5.441 5.192 3.928-3.772c1.503.11 2.92 1.208 3.151 2.65L9.2 17.862a3.944 3.944 0 0 0-2.789-3.023Zm-2.585 3.337c-.05-1.108.78-1.887 1.775-1.772h.004c1.121.112 2.024 1.06 2.076 2.182a1.705 1.705 0 0 1-1.785 1.772c-1.12-.116-2.019-1.062-2.07-2.182Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Diploma;